import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { isIOS, isAndroid } from 'react-device-detect';
import { Cookies } from 'react-cookie';
import translate from '../translate';
import { compose } from '../../services/utilityFunctions';
import { expiredDateInUTC } from '../../services/dateUtilityFunctions';
import TenantProp from '../propTypes/tenantProp';

const MobileAppBanner = props => {
  const {
    t,
    position,
    meta,
    cookies,
    tenant,
  } = props;
  const [isOpen, setIsOpen] = useState(true);
  const title = meta && meta.appName ? meta.appName : 'Bravon';
  const author = 'Bravon S.à.R.L';
  const androidIcon = '/playStore.png';
  const iosIcon = '/appStore.png';
  const price = t('free');
  const whereText = {
    ios: t('banner.store.text.ios'),
    android: t('banner.store.text.android'),
  };
  const description = `${price} - ${isIOS ? whereText.ios : whereText.android}`;
  const daysHidden = 0;

  const bravonIcon = tenant?.branding?.mobileStoreIcon;
  const linkToStore = isIOS ? (
    tenant?.configs?.appleApp || ''
  ) : (
    tenant?.configs?.googleApp || ''
  );
  const isExpire = () => {
    const cookieDateTime = cookies.get('smartbanner-closed') && parseInt(cookies.get('smartbanner-closed'), 10);
    if (cookieDateTime) {
      const isExpireTime = new Date().valueOf() > cookieDateTime;
      if (isExpireTime) {
        cookies.remove('smartbanner-closed');
        return false;
      }
      return true;
    }
    return false;
  };
  const icon = isIOS ? iosIcon : androidIcon;

  const handleClose = () => {
    let domain = window.location.hostname;
    const urlElements = window.location.hostname.split('.');
    if (urlElements.length > 2) {
      domain = `.${urlElements[urlElements.length - 2]}.${urlElements[urlElements.length - 1]}`;
    }
    const date = expiredDateInUTC(daysHidden);
    cookies.set('smartbanner-closed', date.valueOf(), {
      domain,
      path: '/',
      expires: date,
    });
    setIsOpen(false);
  };

  const isMobile = isIOS || isAndroid;
  return (
    <div>
      {isMobile && isOpen && !isExpire() && linkToStore?.length > 0 && (
        <div className={`smartbanner smartbanner-ios smartbanner-${position}`}>
          <div className="smartbanner-container">
            <button type="button" className="smartbanner-close" aria-label="close" onClick={handleClose}>
              &times;
            </button>
            <span className="smartbanner-icon" style={{ backgroundImage: `url(${bravonIcon || icon})` }} />
            <div className="smartbanner-info">
              <div className="smartbanner-title">{title}</div>
              <div className="smartbanner-author">{author}</div>
              <div className="smartbanner-description">{description}</div>
            </div>
            <div className="smartbanner-wrapper">
              <a
                href={linkToStore}
                onClick={() => {}}
                className="smartbanner-button"
              >
              <span className="smartbanner-button-text">
                {t('view')}
              </span>
              </a>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

MobileAppBanner.propTypes = {
  t: PropTypes.func.isRequired,
  position: PropTypes.string,
  meta: PropTypes.shape({
    appName: PropTypes.string.isRequired,
  }).isRequired,
  cookies: PropTypes.instanceOf(Cookies).isRequired,
  tenant: PropTypes.shape(TenantProp.propType).isRequired,
};

MobileAppBanner.defaultProps = {
  position: 'top',
};

export default compose(
  translate,
)(MobileAppBanner);
